import { CrossIcon } from '@fukuri-admins/ui/common/Icons';
import React from 'react';
import styles from './styles.module.scss';

type Props = {
  /** プレビュー画像のURL（ObjectURL または Base64） */
  src: string;
  alt: string;
  onRemove: () => void;
};

export const ImagePreview: React.FC<Props> = ({ src, alt, onRemove }) => (
  <div className={styles.wrapper}>
    <img src={src} alt={alt} className={styles.image} />
    {/* 右上の削除ボタン: 32×32px、白背景・ボーダー付き */}
    <button
      type='button'
      className={styles.removeButton}
      onClick={onRemove}
      aria-label='画像を削除'
    >
      <CrossIcon size='xs' />
    </button>
  </div>
);
